(function () {
  'use strict';

  // =====================================================
  // CONFIGURACIÓN
  // =====================================================

  const PARTNERS_VALIDOS = [
    'claro'
  ];

  const STORAGE_KEY = 'partner';

  // =====================================================
  // PARTNER MANAGER
  // =====================================================

  const PartnerManager = {

 init() {
  console.log('Partner Manager iniciado');
  this.detectarPartner();
},

    detectarPartner() {

      const params = new URLSearchParams(window.location.search);
      const partner = params.get('partner');

      if (!partner) {
        console.log('Esta visita no tiene partner.');

        const partnerGuardado = this.obtenerPartner();

        if (partnerGuardado) {
          console.log('Partner activo en esta sesión:', partnerGuardado);
        }

        return;
      }

      if (!PARTNERS_VALIDOS.includes(partner)) {
        console.warn('Partner no autorizado:', partner);
        return;
      }

      console.log('Partner detectado:', partner);

      this.guardarPartner(partner);

      this.limpiarURL();
    },

    guardarPartner(partner) {
      sessionStorage.setItem(STORAGE_KEY, partner);
      console.log('Partner guardado en la sesión:', partner);
    },

    obtenerPartner() {
      return sessionStorage.getItem(STORAGE_KEY);
    },

    limpiarURL() {

      const url = new URL(window.location);

      url.searchParams.delete('partner');

      window.history.replaceState({}, '', url);

      console.log('URL limpiada.');
    }

  };

  PartnerManager.init();

})();